import { render, staticRenderFns } from "./chinaAreaHp.vue?vue&type=template&id=578c5638&scoped=true"
import script from "./chinaAreaHp.vue?vue&type=script&lang=js"
export * from "./chinaAreaHp.vue?vue&type=script&lang=js"
import style0 from "./chinaAreaHp.vue?vue&type=style&index=0&id=578c5638&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578c5638",
  null
  
)

export default component.exports